import { render, staticRenderFns } from "./commonTools.vue?vue&type=template&id=1dd6d12b&scoped=true"
import script from "./commonTools.vue?vue&type=script&lang=js"
export * from "./commonTools.vue?vue&type=script&lang=js"
import style0 from "./commonTools.vue?vue&type=style&index=0&id=1dd6d12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6d12b",
  null
  
)

export default component.exports